// extracted by mini-css-extract-plugin
module.exports = {"list":"styles-module--list--2QY0L"};